import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ECommerceStoreSelectionModalFacade } from '../../e-commerce-store-selection-modal.facade';
import { EStore } from '@gelato-api-ui/core/e-commerce/e-store';

@Component({
  selector: 'gd-e-commerce-store-selection-modal-container',
  templateUrl: './e-commerce-store-selection-modal-container.component.html',
  styleUrls: ['./e-commerce-store-selection-modal-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ECommerceStoreSelectionModalContainerComponent {
  storesList$ = this.facade.storesList$;

  constructor(private readonly facade: ECommerceStoreSelectionModalFacade) {}

  selectStore(store: EStore) {
    this.facade.selectStore(store);
  }
}
